"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useRef } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
const testimonials = [{
  author: "S",
  quote: "Miles is a valuable collaborator in the studio whose experience and expertise provided helpful direction throughout the recording process and compensated for my knowledge gaps. I am extremely grateful for Miles' contributions in producing my music and would happily work with him again",
  position: "Sam Broberg"
}, {
  author: "R",
  quote: "Working with Miles was a great experience. He understood the darker, atmospheric direction we were aiming for and helped shape the songs in a way that felt natural. The final results really captured what we were hoping for, and I'd work with Miles again in a heartbeat.",
  position: "Row Forrest"
}];
export default function ClientSuccessStories() {
  const watermarkRef = useRef<HTMLDivElement>(null);
  const handleMouseMove = (e: React.MouseEvent<HTMLElement>) => {
    if (!watermarkRef.current) return;
    const {
      clientX,
      clientY
    } = e;
    const moveX = (clientX / window.innerWidth - 0.5) * 40;
    const moveY = (clientY / window.innerHeight - 0.5) * 40;
    (watermarkRef.current.style as any).transform = `translate(${moveX}px, ${moveY}px)`;
  };
  return <section className="py-16 px-4" onMouseMove={handleMouseMove}>
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-12 text-center">Client Success Stories</h2>
        
        <Carousel className="w-full">
          <CarouselContent>
            {testimonials.map((testimonial, index) => <CarouselItem key={index}>
                <div className="p-8 bg-slate-50 rounded-lg">
                  <p className="text-lg mb-6 italic !text-[rgba(0,0,0,1)]">"{testimonial.quote}"</p>
                  <div className="flex items-center gap-4">
                    <SafeHydrate><Avatar>
                      <AvatarFallback>{testimonial.author.charAt(0)}</AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div>
                      <p className="font-semibold">{testimonial.author}</p>
                      <p className="text-sm text-gray-600">{testimonial.position}</p>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
        
        <div ref={watermarkRef} className="fixed pointer-events-none opacity-5 text-6xl font-bold transition-transform duration-150" style={{
        bottom: '20px',
        right: '20px'
      }}>
          MILES
        </div>
      </div>
    </section>;
}